import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// In-app auth routes
export const REGISTER_URL = "/register";
export const LOGIN_URL = "/login";
// phpVMS site links
export const SITE_URL = process.env.REACT_APP_SITE_URL || "https://crew.airindiavirtual.net";
export const SITE_REGISTER_URL = `${SITE_URL}/register`;
export const SITE_DASHBOARD_URL = `${SITE_URL}/dashboard`;
export const SITE_PROFILE_URL = `${SITE_URL}/profile`;
export const FORGOT_PASSWORD_URL = `${SITE_URL}/password/reset`;

const client = axios.create({ baseURL: API });

// --- Public landing data ---
export const getStats = () => client.get("/stats").then((r) => r.data);
export const getPartners = () => client.get("/partners").then((r) => r.data);
export const getNewestPilots = () =>
  client.get("/pilots/newest").then((r) => r.data);
// --- Public leaderboard rows (period: alltime | month) ---
export const getLeaderboard = (metric, period = "alltime") =>
  client
    .get("/leaderboard", { params: { metric, period } })
    .then((r) => r.data);

export const getLeaderboardMonthLabel = () =>
  client.get("/leaderboard/month-label").then((r) => r.data.label);
export const getAwards = () => client.get("/awards").then((r) => r.data);
export const getRanks = () => client.get("/ranks").then((r) => r.data.data);

// --- Auth session (phpVMS per-user API key stored client-side) ---
const KEY_STORE = "aiv_api_key";
const USER_STORE = "aiv_user";
const META_STORE = "aiv_meta";

export const saveSession = (apiKey, user, meta = {}) => {
  localStorage.setItem(KEY_STORE, apiKey);
  localStorage.setItem(USER_STORE, JSON.stringify(user || {}));
  localStorage.setItem(META_STORE, JSON.stringify(meta || {}));
};
export const getApiKey = () => localStorage.getItem(KEY_STORE);
export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_STORE) || "null");
  } catch {
    return null;
  }
};
export const getMeta = () => {
  try {
    return JSON.parse(localStorage.getItem(META_STORE) || "{}");
  } catch {
    return {};
  }
};
export const isAdmin = () => !!getMeta()?.is_admin;
export const clearSession = () => {
  localStorage.removeItem(KEY_STORE);
  localStorage.removeItem(USER_STORE);
  localStorage.removeItem(META_STORE);
};
export const isAuthed = () => !!getApiKey();

const authHeader = () => ({ headers: { "X-Pilot-Key": getApiKey() || "" } });

// --- Auth + pilot data (phpVMS) ---
export const loginPilot = (apiKey) =>
  client.post("/auth/login", { api_key: apiKey }).then((r) => r.data);
export const getMe = () => client.get("/me", authHeader()).then((r) => r.data);
export const getMyBids = () =>
  client.get("/me/bids", authHeader()).then((r) => r.data.data);
export const getMyFleet = () =>
  client.get("/me/fleet", authHeader()).then((r) => r.data.data);

// --- Public live flights (before login) ---
export const getLiveFlights = () =>
  client.get("/live-flights").then((r) => r.data);

// --- Recent routes (shown on the map when no live flights) ---
export const getRecentRoutes = () =>
  client.get("/recent-routes").then((r) => r.data.data);

// --- Full pilot roster (via DisposableBasic /dbapi/roster) ---
export const getRoster = () =>
  client.get("/roster").then((r) => r.data);

// --- News (via DisposableBasic /dbapi/news) ---
export const getNews = () =>
  client.get("/news").then((r) => r.data);

// --- Events (via DisposableBasic /dbapi/events) ---
export const getEvents = () =>
  client.get("/events").then((r) => r.data);

// --- Activity feed: recent accepted PIREPs (via DisposableBasic /dbapi/pireps) ---
export const getRecentPireps = () =>
  client.get("/flights/recent").then((r) => r.data);

// --- Tours (via DisposableSpecial /dsapi/tours) ---
export const getTours = () =>
  client.get("/tours").then((r) => r.data);
